import {Component, Input, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {AbstractControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'slnk-shared-checkbox-validator-item',
  templateUrl: './shared-checkbox-validator-item.component.html',
  styleUrls: ['./shared-checkbox-validator-item.component.scss'],
  standalone: false,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('200ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class SharedCheckboxValidatorItemComponent implements OnInit {
  @Input() control: AbstractControl;
  @Input() errorMessage = this.translate.instant('shared.components.shared_checkbox_validator.error_message');

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  public get shouldShowError(): boolean {
    if (!this.control) {
      return false;
    }
    return this.control.invalid && this.control.touched;
  }
}
